// C.1 — общий реестр Order-функций для новых юнитов v6 (Глобал и Лив Лайф).
//
// Используется в deus/index.js fireUnitOrderById как default-fallback после
// перебора legacy switch'а. Без этого реестра order-юниты v6 (Кладовщик,
// Хронос, Био-террор Зеро и т.п.) не срабатывают при размещении.
//
// API:
//   registerC1Order(cardId, fn) — регистрация Order. fn(state, unit, opts) → result.
//   fireC1Order(state, ownerIdx, unit, opts) → result | null если не зарегистрирован.

const _registry = new Map();

export function registerC1Order(cardId, fn) {
  if (typeof cardId !== 'string' || typeof fn !== 'function') return;
  _registry.set(cardId, fn);
}

export function fireC1Order(state, ownerIdx, unit, opts = {}) {
  if (!unit || !unit.id) return null;
  const fn = _registry.get(unit.id);
  if (!fn) return null;
  try {
    return fn(state, unit, opts);
  } catch (e) {
    console.warn(`[Корпы] C.1 Order ${unit.id} упал:`, e);
    return null;
  }
}

export function hasC1Order(cardId) {
  return _registry.has(cardId);
}

export function _resetC1OrderRegistryForTests() {
  _registry.clear();
}
